import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { DeliveredInBoxBlock as DeliveredInBoxBlockValue } from "@reactivated";
import type { ImageChooserBlock } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { richHTML } from "../../utils/html";

import styles from "./index.module.scss";

const getImageAlt = (
    image: Immutable<ImageChooserBlock> | null | undefined,
): string => image?.default_alt_text || image?.title || "";

export const DeliveredInBoxBlock = (
    block: Immutable<{ value: DeliveredInBoxBlockValue }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.deliveredInBox,
            block.value.background_style?.style ?? "",
            getGlobalSpacingClasses(block.value.spacing),
        ])}
    >
        <div
            className={concatClassNames([
                "main-container",
                styles.deliveredInBoxContent,
            ])}
        >
            {block.value.image ? (
                <img
                    src={block.value.image.url}
                    alt={getImageAlt(block.value.image)}
                    className={styles.deliveredInBoxDogImg}
                    loading="lazy"
                    decoding="async"
                />
            ) : null}
            <div className={styles.deliveredInBoxText}>
                <h2>{block.value.title}</h2>
                <div
                    dangerouslySetInnerHTML={richHTML(block.value.paragraph)}
                />
            </div>
        </div>
    </section>
);
